import './index.scss';
import 'utils/ajax_form';
import { handleApiError } from 'utils/api_error_handler';

class FeedbackForm {
  constructor(context) {
    const $element = $('.js-feedback-form', $(context));

    if (!$element.length) {
      return;
    }

    this.$component = $($element.get(0));
    this.$likeButtons = $('.q-likes-btn', this.$component);
    this.$likeInputs = $(
      `[name="${this.config.resourceKey}[reaction]"]`,
      this.$component
    );
    this.$cancelButton = $('.js-cancel-btn', this.$component);
    this.$answerField = $('#js-answer-field', this.$component);
    this.$feedbackOptions = $('.js-option-feedback', this.$component);
    this.$feedbackLabels = $('.q-commentary-feedback-options', this.$component);
    this.$textarea = $('textarea', this.$answerField);
    this.$submitButton = $('button[type="submit"]', this.$answerField);
    this.isFeedbackSent = false;
    this.isLikeReaction = false;

    this.validationRules = {
      textarea: {
        minLength: 30,
        isValid: false
      },
      feedbackOption: {
        isValid: false
      }
    };

    this.bind();
  }

  get config() {
    return this.$component.data();
  }

  resetForm() {
    this.$textarea.val('');
    this.$feedbackOptions.prop('checked', false);

    this.validationRules.textarea.isValid = false;
    this.validationRules.textarea.minLength = 30;
    this.validationRules.feedbackOption.isValid = false;

    this.validateForm();
  }

  setReaction(e) {
    const inputValue = e.currentTarget.value;
    this.reaction = this.getReaction(inputValue);
    this.isLikeReaction = this.reaction === 'liked';

    if (this.reaction === 'disliked') {
      this.validationRules.textarea.minLength = 0;
      this.validationRules.textarea.isValid = true;
    } else {
      this.validationRules.textarea.minLength = 30;
    }
  }

  swapAnswerFieldClasses() {
    if (this.isLikeReaction) {
      this.$feedbackLabels.hide();
      !this.feedbackId && this.sendFeedback();
      this.$answerField.addClass('q-answer--like').show();
      this.$submitButton.text('Enviar comentário');
      this.$textarea.attr(
        'placeholder',
        'Por favor, escreva ao menos 30 caracteres :)'
      );
      return;
    }
    this.$feedbackLabels.show();
    this.$submitButton.text('Enviar voto negativo');
    this.$textarea.attr('placeholder', 'Nos de mais detalhes (opcional)');
    this.$answerField.addClass('q-answer--dislike').show();
  }

  validateForm() {
    const isFormValid = this.isLikeReaction
      ? this.validationRules.textarea.isValid
      : this.validationRules.textarea.isValid &&
        this.validationRules.feedbackOption.isValid;

    this.$submitButton.attr('disabled', !isFormValid);
  }

  bind() {
    this.$likeInputs.on('change', e => {
      if (!this.isFeedbackSent) {
        this.resetForm();
        this.setReaction(e);
        this.swapAnswerFieldClasses();
      }
    });

    this.$textarea.on('input', e => {
      const { value } = e.currentTarget;
      this.validationRules.textarea.isValid =
        value.length >= this.validationRules.textarea.minLength;
      this.validateForm();
    });

    this.$feedbackOptions.on('change', e => {
      if (this.isLikeReaction) {
        return;
      }
      const { value } = e.currentTarget;
      this.validationRules.feedbackOption.isValid = !!value;
      this.validateForm();
    });

    this.$component
      .ajaxForm(false)
      .lazyReady()
      .on('submit', e => {
        e.preventDefault();
        this.sendFeedback();
        return false;
      });

    this.$cancelButton.on('click', () => {
      this.$likeInputs.prop('checked', false);
      this.$answerField.hide();
      this.resetForm();
    });
  }

  getReaction(reaction) {
    const list = {
      1: 'liked',
      2: 'disliked'
    };

    return list[reaction];
  }

  setReactionButtonAsMarked(isLikeReaction) {
    const buttonSelector = isLikeReaction ? '.q-like' : '.q-dislike';

    const $buttonElement = $(buttonSelector, this.$component).find('.q-icon');

    const { classToAdd, classToRemove } = $buttonElement.data();

    if (classToAdd && classToRemove) {
      $buttonElement.addClass(classToAdd);
      $buttonElement.removeClass(classToRemove);
    }
  }

  updateFeedback() {
    this.thorResource
      .update(
        { id: this.feedbackId },
        {
          data: this.feedbackContent
        }
      )
      .then(() => {
        this.handleFeedbackSuccess();
      })
      .catch(({ response }) => {
        this.handleError(response);
      });
  }

  setFeedbackData() {
    const formData = this.$component.serializeObject();
    const selectedOption = this.$feedbackOptions.filter(':checked').val();
    const textareaValue = this.$textarea.val();

    if (this.isLikeReaction) {
      formData[this.config.resourceKey].answer = textareaValue;
    } else {
      formData[this.config.resourceKey].answer = `${selectedOption}${
        textareaValue ? ` - ${textareaValue}` : ''
      }`;
    }

    this.feedbackContent = formData;
    this.thorResource = Thor[this.config.resourceName];
  }

  handleError(err) {
    handleApiError(null, err);
    this.$component.trigger('ajax:error');
    this.$likeButtons.attr('disabled', false);
  }

  handleFeedbackSuccess() {
    if (
      !this.isLikeReaction ||
      (this.isLikeReaction && this.$textarea.val().length > 0)
    ) {
      this.isFeedbackSent = true;
      this.$answerField.hide();
    }

    this.$component
      .clearForm()
      .trigger('ajax:success')
      .addClass('q-feedback-form--replied')
      .data('replied', true);

    this.$likeInputs.remove();

    this.$likeButtons.attr({
      title: this.config.alreadyRepliedMessage,
      'data-toggle': 'tooltip',
      disabled: false
    });
    this.$likeButtons.removeAttr('for');
  }

  updateCounterValue() {
    const isLikeReaction = this.reaction === 'liked';
    const counterSelector = `.js-${
      isLikeReaction ? 'likes' : 'dislikes'
    }-count`;
    const $counter = $(counterSelector, this.$component);
    const currentValue = parseInt($counter.html());

    this.setReactionButtonAsMarked(isLikeReaction);
    $counter.html(currentValue + 1);
  }

  sendFeedback() {
    this.setFeedbackData();

    if (!this.thorResource) {
      throw Error(`Model '${this.config.resourceName}' not found in Thor.`);
    }

    this.$likeButtons.attr('disabled', true);

    if (this.feedbackId) {
      return this.updateFeedback();
    }

    this.thorResource
      .create(
        {},
        {
          data: this.feedbackContent
        }
      )
      .then(data => {
        this.feedbackId = data.id;
        this.handleFeedbackSuccess();
        this.updateCounterValue();
      })
      .catch(({ response }) => {
        this.handleError(response);
      });
  }
}

export default FeedbackForm;
